import type { Regulation } from "./regulationTypes";
import { regulation2025_2026 } from "./regulation-2025-2026.ts";
import { regulation2026_2027 } from "./regulation-2026-2027.ts";

/** Regolamenti disponibili, dal più recente. Per una nuova stagione aggiungere il file e inserirlo qui in testa. */
export const REGULATIONS: Regulation[] = [regulation2026_2027, regulation2025_2026];

/** Regolamento della stagione indicata; se manca (stagione nuova non ancora caricata) il più recente */
export function regulationFor(seasonCode: string | undefined): Regulation {
  return REGULATIONS.find((r) => r.seasonCode === seasonCode) ?? REGULATIONS[0];
}
